var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('div',{attrs:{"id":"chart-year"}},[_c('vue-apex-charts',{attrs:{"type":"bar","height":"400","options":this.dataxaxis,"series":this.dataseries}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }